import { AdminReportsService } from '../../../../../services/admin-reports.service'
import { handleExport } from '../../../../../actions/export-report.actions'

const exportData = params =>
	handleExport(
		params,
		`${AdminReportsService.baseURL}/breakage-exportar-extrato-de-pontos`,
		'breakage-de-pontos.csv'
	)

export const pointsBreakageActions = { exportData }
